class ArticleFeaturedProductsDrawer extends HTMLDivElement {
  constructor() {
    super();

    this.elements = {
      productsContainer: this.querySelector('[data-article-featured-products-drawer-el="products"]')
    }
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    window.addEventListener('article-featured-products-drawer:update', this.handleUpdate.bind(this));
  }

  handleUpdate(event) {
    const { drawerContent } = event.detail;

    this.elements.productsContainer.innerHTML = '';

    this.elements.productsContainer.appendChild(drawerContent);
  }
}

customElements.define('article-featured-products-drawer', ArticleFeaturedProductsDrawer, { extends: 'div' });
